import React from 'react';
import PropTypes from 'prop-types';
import styles from './StopoverRefreshing.module.scss';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSync} from "@fortawesome/free-solid-svg-icons";
import {connect} from "react-redux";

const StopoverRefreshing = ({refreshing, ...props}) => {

    if (!refreshing) {
        return null
    }

    return (
        <div className={styles.container}>
            <FontAwesomeIcon icon={faSync} spin/>
        </div>
    );
};

StopoverRefreshing.propTypes = {
    refreshing: PropTypes.bool,
};

StopoverRefreshing.defaultProps = {
    refreshing: false,
};

export {StopoverRefreshing};

export default connect(state => ({refreshing: !state.flightCourse.stopover.availabilityLoaded}))(StopoverRefreshing);